// extracted by mini-css-extract-plugin
export default {"attention":"lg5V1","icon":"SFkoC","text":"hDvgT"};